// frontend/src/screens/admin/sps/EmailLogScreen.jsx
import { useState } from 'react';
import {
  Container, Row, Col, Table, Badge, Form, Alert, Spinner, Pagination,
} from 'react-bootstrap';
import { useGetEmailLogQuery } from '../../../slices/spsApiSlices';

const YEAR_OPTIONS = Array.from({ length: 2025 - 2013 + 1 }, (_, i) => 2013 + i);

export default function EmailLogScreen() {
  const [pps,    setPps]    = useState('');
  const [status, setStatus] = useState('');
  const [year,   setYear]   = useState('');
  const [page,   setPage]   = useState(1);

  const queryParams = {
    page,
    ...(pps    && { pps }),
    ...(status && { status }),
    ...(year   && { year }),
  };
  const { data, isLoading, isError } = useGetEmailLogQuery(queryParams);
  const logs  = data?.logs  || [];
  const pages = data?.pages || 1;
  const total = data?.total || 0;

  if (isLoading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;
  if (isError)   return <Alert variant="danger" className="m-3">Failed to load email log.</Alert>;

  return (
    <Container fluid className="py-3">
      <Row className="align-items-center mb-3">
        <Col>
          <h4 className="mb-0">Email Delivery Log</h4>
          <small className="text-muted">{total.toLocaleString()} emails in log</small>
        </Col>
      </Row>

      <Row className="g-2 mb-3">
        <Col xs={12} sm={4} md={3}>
          <Form.Control
            size="sm"
            placeholder="Filter by PPS…"
            value={pps}
            onChange={(e) => { setPps(e.target.value.toUpperCase()); setPage(1); }}
            style={{ fontFamily: 'monospace' }}
          />
        </Col>
        <Col xs={6} sm={3} md={2}>
          <Form.Select size="sm" value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}>
            <option value="">All statuses</option>
            <option value="sent">Sent</option>
            <option value="failed">Failed</option>
            <option value="bounced">Bounced</option>
          </Form.Select>
        </Col>
        <Col xs={6} sm={3} md={2}>
          <Form.Select size="sm" value={year} onChange={(e) => { setYear(e.target.value); setPage(1); }}>
            <option value="">All years</option>
            {YEAR_OPTIONS.map((y) => <option key={y} value={y}>{y}</option>)}
          </Form.Select>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table bordered hover size="sm" style={{ fontSize: '.81rem' }}>
          <thead className="table-dark">
            <tr>
              <th>Date sent</th>
              <th>PPS</th>
              <th>Name</th>
              <th>Email address</th>
              <th className="text-center">Year</th>
              <th>Attachments</th>
              <th>Status</th>
              <th>Sent by</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && (
              <tr><td colSpan={8} className="text-center text-muted py-3">No email records found</td></tr>
            )}
            {logs.map((e) => (
              <tr key={e._id}>
                <td>{new Date(e.sentAt).toLocaleString('en-IE')}</td>
                <td style={{ fontFamily: 'monospace', fontSize: '.75rem' }}>{e.ppsNumber}</td>
                <td>{e.staffName}</td>
                <td style={{ fontSize: '.75rem' }}>{e.emailAddress}</td>
                <td className="text-center">{e.statementYear}</td>
                <td style={{ fontSize: '.72rem' }}>
                  {(e.attachments || []).map((a, i) => (
                    <div key={i} className="text-muted">{a}</div>
                  ))}
                </td>
                <td>
                  <Badge bg={e.status === 'sent' ? 'success' : e.status === 'failed' ? 'danger' : 'warning'}>
                    {e.status}
                  </Badge>
                  {e.errorMessage && (
                    <div className="text-danger" style={{ fontSize: '.7rem', marginTop: 2 }}>
                      {e.errorMessage}
                    </div>
                  )}
                </td>
                <td>{e.sentBy?.name || '—'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {pages > 1 && (
        <div className="d-flex justify-content-center mt-3">
          <Pagination size="sm">
            <Pagination.Prev disabled={page === 1} onClick={() => setPage(page - 1)} />
            {Array.from({ length: Math.min(pages, 10) }, (_, i) => i + 1).map((p) => (
              <Pagination.Item key={p} active={p === page} onClick={() => setPage(p)}>{p}</Pagination.Item>
            ))}
            <Pagination.Next disabled={page === pages} onClick={() => setPage(page + 1)} />
          </Pagination>
        </div>
      )}
    </Container>
  );
}
